import { render, staticRenderFns } from "./ContactsAssignable.vue?vue&type=template&id=fabfcf46&"
import script from "./ContactsAssignable.vue?vue&type=script&lang=js&"
export * from "./ContactsAssignable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports